import { connect } from "react-redux";
import { changeMenu } from "./gameMenuActions";
import GameListSwitcher from "./GameListSwitcher.jsx";

const mapStateToProps = (state) => {
  return {
    currentKey: state.gamesMenu.current ? state.gamesMenu.current.key : {},
    showPreLive: state.user.permissionLevel >= 4,
    isLoggedIn: state.user.loggedIn,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFetchGames: (status, scope) => {
      dispatch(changeMenu({ status, scope }));
    },
  };
};

const GameListSwitcherContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(GameListSwitcher);

export default GameListSwitcherContainer;
